import { createProvider } from "../Common/Provider"
import { APIJobModel } from "../../../Models/API/JobModel"
import { getJob } from "../../../Actions/API/Job/JobActions"
import { FetchState } from "../../../Models/Client/FetchState"

export interface CurrentJobProviderProps {
    appID: string
    jobID: string
}

export const CurrentJobProvider = createProvider<
    FetchState<APIJobModel>,
    CurrentJobProviderProps
>(
    (state, { appID, jobID }) => {
        const table = state.api.jobs.table[appID]

        return table === undefined ? undefined : table.records.get(jobID)
    },
    ({ jobID, appID }) => getJob(appID, jobID)
)
